import React from "react";
import "./Specs_Details_Modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Form, FormGroup } from "react-bootstrap";

const Specs_Details_Modal = (props) => {
  const data = [
    {
      label: "Frame type",
      value: "Full",
    },
    {
      label: "Shape",
      value: "Cateye",
    },
    {
      label: "Colour",
      value: "Green + Transparent",
    },
    {
      label: "Size",
      value: "55-13-140",
    },
    {
      label: "Material",
      value: "Acetate",
    },
  ];

  const labels = ["Distance Vision (DV)", "Near Vision (NV)", "Addition (ADD)"];
  const headers = ["R-SPH", "R-CYL", "R-AXIS", "R-VA"];
  const left_headers = ["L-SPH", "L-CYL", "L-AXIS", "L-VA"];

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Specs_Details_Modal"
      >
         <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="close_img_holder">
              <img
              onClick={() => {props?.onHide()}}
                src="/assets/images/others/close.png"
                className="close_img"
              />
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="content_div">
            <div className="top">
              <div className="row">
                <div className="col-lg-6">
                  <div className="img_text_holder">
                    <p className="heading_text">Order #2535</p>
                    <div className="img_holder">
                      <img
                        src="/assets/images/home/frames/frame2.png"
                        className="specs_img"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="descn_holder">
                    <p className="heading_text">VICTORIA’S SECRET</p>
                    <div className="all_features_div">
                      {data?.map((item) => {
                        return (
                          <div className="feature_div">
                            <p className="label_text">{item?.label}</p>
                            <p className="value_text">{item?.value}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bottom">
              <div className="row">
                <div className="col-lg-6">
                  <div className="eye_section">
                    <div className="section_title"></div>

                    {/* Header Row (hide on mobile) */}
                    <div className="row table_header">
                      <div className="col-sm-4 col-4">
                        <p className="eye_spec_title">RIGHT EYE (OD)</p>
                      </div>
                      {headers.map((head, idx) => (
                        <div
                          className="col-2 p-1 text-center header_cell"
                          key={idx}
                        >
                          <p className="top_text">{head}</p>
                        </div>
                      ))}
                    </div>

                    {/* Body Rows */}
                    {labels.map((label, rowIdx) => (
                      <div
                        className="row align-items-center table_row"
                        key={rowIdx}
                      >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 label_col">
                          <p className="left_text">{label}</p>
                        </div>

                        {headers.map((_, colIdx) => (
                          <div
                            className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                            key={colIdx}
                          >
                            <FormGroup className="input_group">
                              <Form.Control
                                type="text"
                                className="form-control vision-input"
                              />
                            </FormGroup>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="eye_section">
                    <div className="section_title"></div>

                    {/* Header Row (hide on mobile) */}
                    <div className="row table_header">
                      <div className="col-md-4 col-4">
                        <p className="eye_spec_title">LEFT EYE(OS)</p>
                      </div>
                      {left_headers.map((head, idx) => (
                        <div
                          className="col-2 p-1 text-center header_cell"
                          key={idx}
                        >
                          <p className="top_text">{head}</p>
                        </div>
                      ))}
                    </div>

                    {/* Body Rows */}
                    {labels.map((label, rowIdx) => (
                      <div
                        className="row align-items-center table_row"
                        key={rowIdx}
                      >
                        <div className="col-lg-4 col-md-4 col-sm-4 col-4 label_col">
                          <p className="left_text">{label}</p>
                        </div>

                        {left_headers.map((_, colIdx) => (
                          <div
                            className="col-lg p-1 col-md col-sm-2 col-2 input_col"
                            key={colIdx}
                          >
                            <FormGroup className="input_group">
                              <Form.Control
                                type="text"
                                className="form-control vision-input"
                              />
                            </FormGroup>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Specs_Details_Modal;
